import React from 'react';
import '../styles/Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>HZ Landscaping</h3>
            <p>Professional landscaping services for your outdoor dreams.</p>
          </div>
          <div className="footer-section">
            <h4>Contact Us</h4>
            <p>Email: hzlandscapingmarin@gmail.com</p>
            <p>Phone: (415) 305-4327</p>
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li>Planting</li>
              <li>Fence Installation</li>
              <li>Decking</li>
              <li>Maintenance Plans (Weekly & Monthly)</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {currentYear} HZ Landscaping. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
